import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "arrow2_bottom",
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("rect", {
      id: "Rechteck_1787",
      "data-name": "Rechteck 1787",
      width: "24",
      height: "24",
      fill: "none"
    }, null, -1)),
    _createElementVNode("path", {
      id: "arrow2_bottom-2",
      "data-name": "arrow2_bottom",
      d: "M629.874,101a1,1,0,0,1-.707-.293l-6-6a1,1,0,0,1,1.414-1.414l5.293,5.293,5.293-5.293a1,1,0,0,1,1.414,1.414l-6,6A1,1,0,0,1,629.874,101Z",
      transform: "translate(-617.875 -85)",
      class: _normalizeClass(["transition-fill", 'fill-' + _ctx.color])
    }, null, 2)
  ]))
}